module.exports = __webpack_public_path__ + "img/laboBlue.b605b238.svg";